module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mrescir10-4fb0b05524cf8e8bcf0f6dc2b153eba8.jpg";